import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usuarioService } from '../services/api';
import '../Auth.css';

function Registro() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    dni: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validaciones
    if (!formData.nombreCompleto || !formData.dni || !formData.email || !formData.password || !formData.confirmPassword) {
      setError('Por favor, completa todos los campos');
      setLoading(false);
      return;
    }

    if (formData.dni.length !== 8) {
      setError('El DNI debe tener 8 dígitos');
      setLoading(false);
      return;
    }

    if (!validateEmail(formData.email)) {
      setError('Por favor, ingresa un email válido');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    try {
      // Preparar datos para el UsuarioRegistroDTO
      const usuarioRegistroDTO = {
        nombreCompleto: formData.nombreCompleto,
        dni: formData.dni,
        email: formData.email,
        password: formData.password
      };

      // Llamar al servicio de registro
      const usuarioCreado = await usuarioService.registrar(usuarioRegistroDTO);

      // Guardar sesión automáticamente después del registro
      localStorage.setItem('usuarioActual', JSON.stringify({
        id: usuarioCreado.id,
        dni: usuarioCreado.dni,
        nombreCompleto: usuarioCreado.nombreCompleto
      }));

      // Redirigir a la página principal
      alert('¡Registro exitoso! Bienvenido a KANO LIMA.');
      navigate('/');
    } catch (err) {
      console.error('Error en el registro:', err);
      
      // Manejar diferentes tipos de errores
      if (err.message.includes('DNI')) {
        setError('Este DNI ya está registrado');
      } else if (err.message.includes('email')) {
        setError('Este email ya está registrado');
      } else {
        setError(err.message || 'Error al registrar. Por favor, intenta de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card registro-card">
          <div className="auth-header">
            <h1 className="auth-logo" onClick={() => navigate('/')}>
              <span className="logo-text">Novia de Alquiler</span>
              <span className="logo-brand">"Petit Kano"</span>
            </h1>
            <h2 className="auth-title">Crear Cuenta</h2>
            <p className="auth-subtitle">Regístrate para acceder a todos los servicios</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            {error && (
              <div className="auth-error">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="nombreCompleto">Nombre Completo</label>
              <input
                type="text"
                id="nombreCompleto"
                name="nombreCompleto"
                value={formData.nombreCompleto}
                onChange={handleChange}
                placeholder="Tu nombre completo"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="dni">DNI</label>
              <input
                type="text"
                id="dni"
                name="dni"
                value={formData.dni}
                onChange={handleChange}
                placeholder="Ingresa tu DNI (8 dígitos)"
                maxLength="8"
                pattern="[0-9]*"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="tu@email.com"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Mínimo 6 caracteres"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmar Contraseña</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Repite tu contraseña"
                className="form-input"
                disabled={loading}
              />
            </div>

            <button 
              type="submit" 
              className="auth-button"
              disabled={loading}
            >
              {loading ? 'Registrando...' : 'Crear Cuenta'}
            </button>

            <div className="auth-footer">
              <p>¿Ya tienes una cuenta?</p>
              <button 
                type="button"
                onClick={() => navigate('/login')}
                className="auth-link-button"
                disabled={loading}
              >
                Inicia sesión aquí
              </button>
            </div>

            <button 
              type="button"
              onClick={() => navigate('/')}
              className="back-home-button"
              disabled={loading}
            >
              ← Volver al inicio
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Registro;